import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function AdminSettings() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [anonDaily, setAnonDaily] = useState(10);
  const [softGatePct, setSoftGatePct] = useState(80);
  const [hardCaps, setHardCaps] = useState(false);
  const [saving, setSaving] = useState(false);
  const [meteredEndpoints, setMeteredEndpoints] = useState(['dj', 'transcribe']);
  const [overagesEnabled, setOveragesEnabled] = useState(false);

  async function load() {
    setLoading(true);
    setError('');
    try {
      const res = await api.getAdminConfig();
      const cfg = res?.item || {};
      if (cfg.anon_daily_quota_minutes != null) setAnonDaily(Number(cfg.anon_daily_quota_minutes) || 0);
      if (cfg.soft_gate_threshold_percent != null) setSoftGatePct(Number(cfg.soft_gate_threshold_percent) || 0);
      if (cfg.hard_caps_enabled != null) setHardCaps(!!cfg.hard_caps_enabled);
      if (Array.isArray(cfg.metered_endpoints)) setMeteredEndpoints(cfg.metered_endpoints.map(String));
      if (cfg.overages_enabled != null) setOveragesEnabled(!!cfg.overages_enabled);
    } catch (e) {
      setError('Failed to load settings');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  async function onSave() {
    setSaving(true);
    setError('');
    try {
      const patch = {
        anon_daily_quota_minutes: Number(anonDaily) || 0,
        soft_gate_threshold_percent: Number(softGatePct) || 0,
        hard_caps_enabled: !!hardCaps,
        metered_endpoints: meteredEndpoints,
        overages_enabled: !!overagesEnabled,
      };
      const res = await api.setAdminConfig(patch);
      if (res?.error) throw new Error(res.error);
    } catch (e) {
      setError(e?.message || 'Failed to save');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ color: '#ff7a45' }}>Admin Settings</h2>
      {error && <p style={{ color: '#fca5a5' }}>{error}</p>}
      {loading ? (
        <p>Loading…</p>
      ) : (
        <div style={{ display: 'grid', gap: 12, maxWidth: 520, background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16 }}>
          <label style={label}>Anonymous daily quota (minutes)
            <input type="number" value={anonDaily} onChange={(e) => setAnonDaily(Number(e.target.value))} style={input} />
          </label>
          <label style={label}>Soft-gate threshold (%)
            <input type="number" value={softGatePct} onChange={(e) => setSoftGatePct(Number(e.target.value))} style={input} />
          </label>
          <label style={{ ...label, display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" checked={hardCaps} onChange={(e) => setHardCaps(e.target.checked)} /> Enable hard caps
          </label>
          <div>
            <button disabled={saving} onClick={onSave} style={btnPrimary}>{saving ? 'Saving…' : 'Save'}</button>
          </div>
          <div style={{ marginTop: 12 }}>
            <div style={{ color: '#9ca3af', marginBottom: 6 }}>Metered Endpoints</div>
            {['dj', 'transcribe', 'amplify', 'clips', 'uploads'].map(k => (
              <label key={k} style={{ color: '#e5e7eb', display: 'inline-flex', alignItems: 'center', gap: 6, marginRight: 12 }}>
                <input
                  type="checkbox"
                  checked={meteredEndpoints.includes(k)}
                  onChange={(e) => {
                    setMeteredEndpoints(prev => e.target.checked ? Array.from(new Set([...prev, k])) : prev.filter(x => x !== k));
                  }}
                /> {k}
              </label>
            ))}
          </div>
          <label style={{ ...label, display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" checked={overagesEnabled} onChange={(e) => setOveragesEnabled(e.target.checked)} /> Enable overages (coming soon)
          </label>
        </div>
      )}
    </div>
  );
}

const label = { color: '#e5e7eb', display: 'grid', gap: 6 };
const input = { background: '#0b0b0e', color: '#e5e7eb', border: '1px solid #374151', borderRadius: 8, padding: 8 };
const btnPrimary = { background: '#ff5a1f', color: '#fff', border: 0, borderRadius: 8, padding: '8px 12px', cursor: 'pointer' };
